import { useTheme } from "../../styles/ThemeProvider"
import { cn } from "../../lib/utils"

function Skeleton({
  className,
  ...props
}) {
  const { themeObject } = useTheme();
  
  const skeletonTokens = themeObject.components.skeleton || {};
  
  const skeletonStyles = {
    animation: skeletonTokens.animation || 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite',
    borderRadius: skeletonTokens.borderRadius || themeObject.borderRadius?.md || '6px',
    backgroundColor: skeletonTokens.backgroundColor || themeObject.colors.surface.muted,
  };

  return (
    <div
      className={cn("", className)}
      style={skeletonStyles}
      {...props}
    />
  )
}

export { Skeleton }